import React from 'react';

const Footer = () => {
    return (
        <div style={{padding:'20px 0', backgroundColor:'#212F3D', textAlign:'center', color: '#fff'}}>
            <p>Ibrahim Kholilullah &copy; 2021. All Rights Reserved.</p>
        </div>
    );
};

export default Footer;